export const ThreadDaySeparator = ({ label }: { label: string }) => (
  <div className="flex items-center gap-3 py-2">
    <span className="h-px flex-1 bg-blue-2" />
    <span className="shrink-0 text-xs font-medium text-ink-subtle">
      {label}
    </span>
    <span className="h-px flex-1 bg-blue-2" />
  </div>
)
